<ng-container *transloco="let translate;"></ng-container>
